import { useLayoutEffect, useRef, useState } from 'react';
import { getIsMobile } from '../../../utils/getIsMobile';

interface UseHeaderIntersectionOptions {
    containerRef?: React.RefObject<HTMLElement>;
}

/**
 * Отслживает пересечение заголовка с контейнером
 */
export const useHeaderIntersection = (options: UseHeaderIntersectionOptions = {}) => {
    const [isIntersectContent, setIsIntersectContent] = useState(false);
    const targetRef = useRef<HTMLDivElement>(null);
    const { isMobile } = getIsMobile();
    const topOffset = isMobile ? 0 : 16;

    const { containerRef } = options;

    useLayoutEffect(() => {
        const scrollContainer = containerRef?.current;
        const target = targetRef?.current;
        if (!scrollContainer || !target) {
            return;
        }

        const handleScroll = () => {
            const targetRect = target.getBoundingClientRect();

            setIsIntersectContent(targetRect.top - topOffset < 0);
        };

        handleScroll();

        scrollContainer.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            scrollContainer.removeEventListener('scroll', handleScroll);
        };
    });

    return {
        targetRef,
        isIntersectContent,
    };
};
